import * as React from 'react';
import { GlobalHelper } from '../utils/GlobalHelper';

interface InteractorContainerProps {
}

interface InteractorContainerState {
    show: boolean;
}

// Note: this Component is used to add new interactors in some customer branches.
// Do not remove this component (in the master/develeop branch)!
export class InteractorContainer extends React.Component<InteractorContainerProps, InteractorContainerState> {
    public componentWillMount(): void {
        if (GlobalHelper.coreApp.tools.defaultTool != null) {
            GlobalHelper.coreApp.tools.defaultTool.eventStarted.addListener(this.onChange);
            GlobalHelper.coreApp.tools.defaultTool.eventStopped.addListener(this.onChange);
        }

        this.onChange();
    }

    public componentWillUnmount(): void {
        if (GlobalHelper.coreApp.tools.defaultTool != null) {
            GlobalHelper.coreApp.tools.defaultTool.eventStarted.removeListener(this.onChange);
            GlobalHelper.coreApp.tools.defaultTool.eventStopped.removeListener(this.onChange);
        }
    }

    public render(): JSX.Element | null {
        if (!this.state.show) {
            return null;
        }

        return (
            <div className="interactor-container"/>
        );
    }

    protected onChange = (): void => {
        this.setState({
            show: GlobalHelper.coreApp.tools.defaultTool != null && GlobalHelper.coreApp.tools.defaultTool.isRunning()
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/InteractorContainer.tsx